module.exports = __webpack_public_path__ + "img/mask.727b63b6.png";